import cn from "classnames";
import * as React from "react";
import styles from "./CustomDialogFrames.module.less";
export type Frame = React.ComponentType<{
    children?: React.ReactNode;
}>;
export interface DialogFrameProp {
    frame: Frame;
}
export const FrameWrapper = React.forwardRef<HTMLDivElement, BaseFrameProps>(({ children, className }, ref) => (<div ref={ref} className={cn(className, styles.wrapper, styles.frame, styles.padded)}>
        {children}
    </div>));
interface BaseFrameProps {
    className?: string;
    ref?: React.Ref<HTMLDivElement>;
    children?: React.ReactNode;
}
export const DialogFrame = React.forwardRef<HTMLDivElement, BaseFrameProps>(({ children, className }, ref) => {
    return (<div ref={ref} className={cn(styles.frame, styles.shadow, className)}>
            {children}
        </div>);
});
export const FullScreenDialogFrame = React.forwardRef<HTMLDivElement, BaseFrameProps>(({ children, className }, ref) => {
    return (<DialogFrame ref={ref} className={cn(styles.fullscreen, styles.commonFrame, styles.opaque, styles.shadow, className)}>
            {children}
        </DialogFrame>);
});
export const LargeDialogFrame = React.forwardRef<HTMLDivElement, BaseFrameProps>(({ children, className }, ref) => {
    return (<DialogFrame ref={ref} className={cn(styles.huge, styles.commonFrame, styles.opaque, styles.shadow, className)}>
            {children}
        </DialogFrame>);
});
export const MediumDialogFrame = React.forwardRef<HTMLDivElement, BaseFrameProps>(({ children, className }, ref) => (<FrameWrapper>
        <div ref={ref} className={cn(styles.medium, styles.commonFrame, styles.opaque, styles.shadow, className)}>
            {children}
        </div>
    </FrameWrapper>));
export const SmallDialogFrame = React.forwardRef<HTMLDivElement, BaseFrameProps>(({ children, className }, ref) => (<MediumDialogFrame ref={ref} className={cn(styles.small, className)}>
        {children}
    </MediumDialogFrame>));
export const ExtraSmallDialogFrame = React.forwardRef<HTMLDivElement, BaseFrameProps>(({ children, className }, ref) => (<MediumDialogFrame ref={ref} className={cn(styles.extraSmall, className)}>
        {children}
    </MediumDialogFrame>));
export const NoFrame = React.Fragment;
